/*
 * PDP - Regras para coleção "fita-de-borda"
 * Mínimo: 10 unidades | Incremento: 10
 */
(function () {
  const MIN = 10;
  const STEP = 10;

  const norm = (v) => {
    let q = parseInt(v, 10);
    if (!Number.isFinite(q)) q = MIN;
    if (q < MIN) q = MIN;
    if (q % STEP !== 0) q = Math.round(q / STEP) * STEP;
    return q;
  };

  const nextMultiple = (c) => Math.ceil(c / STEP) * STEP + STEP;

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest('button[name="plus"], button[name="minus"]');
      if (!btn || btn.closest(".cart-item")) return;
      const input = document.querySelector('input[name="quantity"]');
      if (!input) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      let current = norm(input.value);
      input.value =
        btn.name === "plus"
          ? nextMultiple(current)
          : Math.max(MIN, current - STEP);
      input.setAttribute("value", input.value);
    },
    { capture: true }
  );

  document.addEventListener("DOMContentLoaded", () => {
    const input = document.querySelector('input[name="quantity"]');
    if (input) {
      input.min = MIN;
      input.step = STEP;
      input.value = norm(input.value);
    }
  });
})();
